import { Reducer } from "redux";

import { OrderingSourceResponse } from "../models/Api/Master";
import { OrderingSourceDispatchTypes } from "../models/DispatchTypes/Master";
import { OrderingSourceActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

const initialState: OrderingSourceResponse = {
  loading: false,
  response: [],
};

const OrderingSource: Reducer<
  OrderingSourceResponse,
  OrderingSourceDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_SUCCESS: {
      setLocalStorageData(
        OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default OrderingSource;
